import { useCallback, useEffect, useState } from 'react'
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Divider,
} from '@mui/material'
import { AttributeGroup } from '../../ShedManagementTypes'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ShedManagementState'

const heightTypes: AttributeGroup = {
  groupName: 'Altura',
  values: [
    { id: 1, name: 'Chão' },
    { id: 2, name: 'Média' },
    { id: 3, name: 'Alta' },
  ],
}

const FormControlHeightType = () => {
  const [selectedOption, setSelectedOption] = useState<number | null>(null)
  const [hasDisabled, setHasDisabled] = useState(false)
  const { selectedLocations } = useSelector((state) => state.shedManagement)
  const dispatch = useDispatch()

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target as HTMLInputElement
    setSelectedOption(Number(value))
    const updatedSelectedLocations = selectedLocations.map((location) => ({
      ...location,
      idLocationHeightType: Number(value),
    }))

    dispatch(actions.setSelectedLocations({ selectedLocations: updatedSelectedLocations }))
  }, [dispatch, selectedLocations])

  useEffect(() => {
    if (selectedLocations.length > 0) {
      const { idLocationHeightType } = selectedLocations[0]
      const hasSameHeightAttribute = selectedLocations.every((location) => location.idLocationHeightType === idLocationHeightType)
      setHasDisabled(hasSameHeightAttribute)

      if (hasSameHeightAttribute) {
        setSelectedOption(idLocationHeightType)
      } else {
        setSelectedOption(null)
      }
    } else {
      setSelectedOption(null)
    }
  }, [selectedLocations])

  return (
    <FormControl>
      <Typography sx={{ padding: '0 0 0 .8rem' }}>{heightTypes.groupName}</Typography>
      <Divider flexItem variant='middle'/>
      <RadioGroup
        value={selectedOption}
        onChange={handleChange}
        row
        sx={{
          padding: '0 0 0 .8rem',
        }}
      >
        {heightTypes.values.map((item) => (
          <FormControlLabel
            key={item.id}
            disabled={!hasDisabled || selectedLocations.length < 1}
            value={item.id}
            control={<Radio />}
            label={item.name}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default FormControlHeightType
